module.exports = __webpack_public_path__ + "img/ic_sageata.03df704f.svg";